var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinecode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.441,
    height: 13.071,
    viewBox: "0 0 32.441 13.071",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linecode",
    transform: "translate(-163.829 -287.912)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrows",
    transform: "translate(0.319)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_75",
    "data-name": "Tracciato 75",
    d: "M6.941,12.769,1.681,17.98l5.259,5.293",
    transform: "translate(162.89 276.447)",
    fill: "none",
    stroke: "#a0a7bb",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_76",
    "data-name": "Tracciato 76",
    d: "M6.941,12.769,1.681,17.98l5.259,5.293",
    transform: "translate(196.572 312.49) rotate(180)",
    fill: "none",
    stroke: "#a0a7bb",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "warning"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linea_19",
    "data-name": "Linea 19",
    x1: 7,
    y2: 11,
    transform: "translate(177.39 288.947)",
    fill: "none",
    stroke: "#a0a7bb",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinecode);
export default __webpack_public_path__ + "static/media/linecode.29850404ee877e8068fe43e1a492bcac.svg";
export { ForwardRef as ReactComponent };